<script>
import { options } from "../config";
import { loading } from "../loader";


    import { PostContact } from "../Services/form0";
    import { user } from "../store";
    import Date from "./Helpers/date.svelte";
     

    export let customer;
    let documents = [];
    let pir = [];
    loading.set(true)
    const getDocuments = (customer) => {
         
        console.log("EEE");
        if (customer) {
            const data = {
                profile: options.profile,
                form: "documents",
                data: {
                    customer: customer,
                },
            };
            PostContact(
                data,
                $user.idToken,
                (data) => {
                    documents = data.app_metadata.documents;
                    pir = data.app_metadata.p;
                    loading.set(false)
                },
                (error) => {
                    console.error(error);
                    loading.set(false)
                }
            );
        }
    };
    $: getDocuments(customer);
</script>

{#if customer}
 
    {#if !$loading}
    <h1>
        PIR Documents
        <a
            href="/#/pir/create/{customer.split('customer/').join('')}"
            class="edit">Add</a>
    </h1>
    <table class="large_table">
        {#each pir as d}
            <tr>
                <td>
                    <a href="/#/pir/edit/{d.contact_uuid}" class="edit"><Date date={d.data.incidentDate} /></a>
                </td>
                <td>{d.data.issue}</td>
                <td>
                    <a href="/#/pir/view/{d.contact_uuid}"><i
                            class="fad fa-eye" /></a>
                </td>
            </tr>
        {/each}
    </table>

    <h1>Onboarding Documents</h1>
    <table class="info_table">
        {#each documents as d}
            <tr>
                <td>
                    <Date date={d.LastModified} />
                </td>
            </tr>
        {/each}
    </table>
    {/if}
{:else}
<h1>Select a customer first</h1>
{/if}
